<template>
  <div class="fixed inset-0 bg-black/32 z-50"><slot /></div>
</template>
